import React from "react";
import { Message } from "semantic-ui-react";
import { ItemLista } from "../../components/Solicitud/ItemLista";
import { ResumenVecino } from "../../components/Vecino/ResumenVecino";
import { ModalDetalle } from "../../components/Solicitud/ModalDetalle";

export const Componentes = () => {
  const error = localStorage.getItem("error");
  const info = localStorage.getItem("info");
  const exito = localStorage.getItem("exito");

  return (
    <div className="container post">
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <h1>Componente Lista de Tiket</h1>
              <ItemLista />
            </div>
            <div className="card-body">
              <h1>Componente Resumen Vecino</h1>
              <ResumenVecino />
            </div>

            <div className="card-body">
              <h1>Modal detalle</h1>
              <ModalDetalle />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
